import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMcLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 16",
	width: 24,
	height: 16,
	"aria-hidden": "true",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_66_2092)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M22.1767 0H2.2359C1.1346 0 0.241821 0.89543 0.241821 2V14C0.241821 15.1046 1.1346 16 2.2359 16H22.1767C23.278 16 24.1707 15.1046 24.1707 14V2C24.1707 0.89543 23.278 0 22.1767 0Z",
				fill: "#252525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.21517 13C11.9684 13 14.2004 10.7614 14.2004 8C14.2004 5.23858 11.9684 3 9.21517 3C6.46193 3 4.22998 5.23858 4.22998 8C4.22998 10.7614 6.46193 13 9.21517 13Z",
				fill: "#EB001B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1974 13C17.9507 13 20.1826 10.7614 20.1826 8C20.1826 5.23858 17.9507 3 15.1974 3C12.4442 3 10.2122 5.23858 10.2122 8C10.2122 10.7614 12.4442 13 15.1974 13Z",
				fill: "#F79E1B"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.2063 3.99963C13.4171 4.91184 14.2004 6.36418 14.2004 8C14.2004 9.63582 13.4171 11.0882 12.2063 12.0004C10.9954 11.0882 10.2122 9.63582 10.2122 8C10.2122 6.36418 10.9954 4.91184 12.2063 3.99963Z",
				fill: "#FF5F00"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_66_2092",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 23.9289,
			height: 16,
			fill: "white",
			transform: "translate(0.241821)"
		})
	}) })]
});
export default SvgMcLogo;
